import ServicePageTemplate from "../components/ServicePageTemplate";
import { IMAGES } from "../data/business";
import { SERVICES } from "../data/services";

export default function FacePage() {
  return (
    <ServicePageTemplate
      service={SERVICES.face}
      heroImage={IMAGES.face}
      secondaryImage={IMAGES.faceAlt}
      breadcrumbLabel="Kosmetyka twarzy"
      bullets={[
        "Diagnoza skóry na wejściu — dobieramy zabieg do Twoich potrzeb, nie do cennika.",
        "Autorskie protokoły łączące pielęgnację manualną i aktywne kosmetyki gabinetowe.",
        "Mezoterapia mikroigłowa, PDRN, biostymulatory — filozofia skin longevity 2026.",
        "Masaż Kobido w gabinecie prowadzonym przez doświadczoną kosmetolog.",
        "Rekomendacja pielęgnacji domowej i realistyczna oś czasowa efektów.",
      ]}
      finalSection={{ title: "Regeneracja zamiast maskowania — najnowszy trend beauty 2026 w BEAUTIX." }}
    />
  );
}
